<template>
  <span
    v-if="svgIcon"
    class="svg-icon"
    :class="[iconClass, { 'icon-disabled': disabled }]"
    :style="svgIconStyle"
    @click="onClick"
    v-html="svgIcon"
  >
  </span>
</template>

<script>
import cn from 'classnames'
import { getSVGIcons } from '~/global/icons/svg-icon'
export default {
  name: 'AcademyIconSVG',
  props: {
    name: {
      type: String,
      required: true,
      default() {
        return ''
      },
    },
    color: {
      type: String,
      default() {
        return ''
      },
    },
    width: {
      type: [Number, String],
      default() {
        return -1
      },
    },
    height: {
      type: [Number, String],
      default() {
        return -1
      },
    },
    iconStyle: {
      type: Object,
      default() {
        return {}
      },
    },
    text: {
      type: String,
      default() {
        return ''
      },
    },
    iconClass: {
      type: String,
      default() {
        return ''
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      },
    },
  },
  computed: {
    svgIcon() {
      const { color, name, text } = this
      const icon = getSVGIcons(name, color, text)
      return icon || null
    },
    svgIconStyle() {
      const { width, height, iconStyle } = this
      const svgIconStyle = Object.assign({}, iconStyle)

      if (+width > 0) {
        svgIconStyle.width = width + 'px'
        svgIconStyle.minWidth = width + 'px'
      }
      if (+height > 0) {
        svgIconStyle.height = height + 'px'
        svgIconStyle.minHeight = height + 'px'
      }
      return svgIconStyle
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) this.$emit('click')
    },
  },
}
</script>

<style lang="scss" scoped>
.svg-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  &.icon-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
